function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import Link from "../../../../Link";
import * as CategoryLinkUI from "./CategoryLink.styles";

var CategoryLink = function CategoryLink(_ref) {
  var children = _ref.children,
      href = _ref.href,
      _ref$isHeader = _ref.isHeader,
      isHeader = _ref$isHeader === void 0 ? false : _ref$isHeader,
      onCategoryClick = _ref.onCategoryClick,
      _ref$isExternalLink = _ref.isExternalLink,
      isExternalLink = _ref$isExternalLink === void 0 ? false : _ref$isExternalLink,
      _ref$isSponsored = _ref.isSponsored,
      isSponsored = _ref$isSponsored === void 0 ? false : _ref$isSponsored,
      linkComponent = _ref.linkComponent;
  var linkProps = isExternalLink ? {
    target: '_blank'
  } : {};

  if (isSponsored) {
    linkProps = _objectSpread(_objectSpread({}, linkProps), {}, {
      rel: 'sponsored'
    });
  }

  return /*#__PURE__*/React.createElement(Link, _extends({
    Component: linkComponent,
    href: href
  }, linkProps), isHeader ? /*#__PURE__*/React.createElement(CategoryLinkUI.TextSubHeadingStyled, {
    onClick: function onClick() {
      return onCategoryClick();
    }
  }, children, /*#__PURE__*/React.createElement(CategoryLinkUI.StyledIconRight, null)) : /*#__PURE__*/React.createElement(CategoryLinkUI.TextCallout2Hover, {
    onClick: function onClick() {
      return onCategoryClick();
    }
  }, children));
};

CategoryLink.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  href: PropTypes.string.isRequired,
  isHeader: PropTypes.bool,
  onCategoryClick: PropTypes.func,
  isExternalLink: PropTypes.bool,
  isSponsored: PropTypes.bool,
  linkComponent: PropTypes.node
} : {};
export default CategoryLink;
//# sourceMappingURL=CategoryLink.js.map